export default "__VITE_ASSET__db6fd5b8__"